export default {
    clear: Boolean
}
